export default __webpack_public_path__ + "static/about-img1-4403e3c1b0ce69ec849c16102963573a.svg";